import type { ReactNode } from 'react';
import { cx } from '@/lib/cx';
import styles from './Lead.module.css';

export interface LeadProps {
  children: ReactNode;
  italic?: boolean;
  align?: 'start' | 'center';
  className?: string;
}

/** Entradilla bajo el titular ("Un viaje de transformación global y cósmica"). */
export function Lead({ children, italic = false, align = 'start', className }: LeadProps) {
  return (
    <p
      className={cx('az-lead', styles.lead, italic && 'az-lead--italic', styles[`align-${align}`], className)}
    >
      {children}
    </p>
  );
}
